// File: frontend/src/pages/SuperAdmin/index.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import Dashboard from './components/Dashboard';
import EnterpriseManagement from './components/EnterpriseManagement';
import UserManagement from './components/UserManagement';
import ProductManagement from './components/ProductManagement';
import AgreementManagement from './components/AgreementManagement';
import SubscriptionManagement from './components/SubscriptionManagement';
import RbacManagement from './components/RbacManagement';
import CommunicationManagement from './components/CommunicationManagement';
import DatasetManagement from './components/DatasetManagement';
import ReportManagement from './components/ReportManagement';
import AuditLogs from './components/AuditLogs';
import SystemSettings from './components/SystemSettings';
import PitchAccessManager from './components/PitchAccessManager';
import styles from './SuperAdmin.module.css';

const SuperAdmin = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('dashboard');

  // Set active section based on URL path
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/super-admin-panel') {
      setActiveSection('dashboard');
    } else if (path.includes('/super-admin-panel/enterprises')) {
      setActiveSection('enterprises');
    } else if (path.includes('/super-admin-panel/users')) {
      setActiveSection('users');
    } else if (path.includes('/super-admin-panel/products')) {
      setActiveSection('products');
    } else if (path.includes('/super-admin-panel/agreements')) {
      setActiveSection('agreements');
    } else if (path.includes('/super-admin-panel/subscriptions')) {
      setActiveSection('subscriptions');
    } else if (path.includes('/super-admin-panel/rbac')) {
      setActiveSection('rbac');
    } else if (path.includes('/super-admin-panel/communications')) {
      setActiveSection('communications');
    } else if (path.includes('/super-admin-panel/datasets')) {
      setActiveSection('datasets');
    } else if (path.includes('/super-admin-panel/reports')) {
      setActiveSection('reports');
    } else if (path.includes('/super-admin-panel/audit-logs')) {
      setActiveSection('audit-logs');
    } else if (path.includes('/super-admin-panel/settings')) {
      setActiveSection('settings');
    } else if (path.includes('/super-admin-panel/pitch-access')) {
      setActiveSection('pitch-access');
    }
  }, [location.pathname]);

  // Handle navigation between sections
  const handleNavigation = (section) => {
    setActiveSection(section);
    
    // Navigate to the appropriate route
    switch (section) {
      case 'dashboard':
        navigate('/super-admin-panel');
        break;
      case 'settings':
        navigate('/super-admin-panel/settings');
        break;
      case 'enterprises':
        navigate('/super-admin-panel/enterprises');
        break;
      case 'users':
        navigate('/super-admin-panel/users');
        break;
      case 'products':
        navigate('/super-admin-panel/products');
        break;
      case 'agreements':
        navigate('/super-admin-panel/agreements');
        break;
      case 'subscriptions':
        navigate('/super-admin-panel/subscriptions');
        break;
      case 'rbac':
        navigate('/super-admin-panel/rbac');
        break;
      case 'communications':
        navigate('/super-admin-panel/communications');
        break;
      case 'datasets':
        navigate('/super-admin-panel/datasets');
        break;
      case 'reports':
        navigate('/super-admin-panel/reports');
        break;
      case 'audit-logs':
        navigate('/super-admin-panel/audit-logs');
        break;
      case 'pitch-access':
        navigate('/super-admin-panel/pitch-access');
        break;
      default:
        navigate('/super-admin-panel');
    }
  };

  // Render the active section
  const renderActiveSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigation} />;
      case 'settings':
        return <SystemSettings />;
      case 'enterprises':
        return <EnterpriseManagement />;
      case 'users':
        return <UserManagement />;
      case 'products':
        return <ProductManagement />;
      case 'agreements':
        return <AgreementManagement />;
      case 'subscriptions':
        return <SubscriptionManagement />;
      case 'rbac':
        return <RbacManagement />;
      case 'communications':
        return <CommunicationManagement />;
      case 'datasets':
        return <DatasetManagement />;
      case 'reports':
        return <ReportManagement />;
      case 'audit-logs':
        return <AuditLogs />;
      case 'pitch-access':
        return <PitchAccessManager />;
      default:
        return <Dashboard onNavigate={handleNavigation} />;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.sectionContent}>
        {renderActiveSection()}
      </div>
    </div>
  );
};

export default SuperAdmin;